import { createSlice } from '@reduxjs/toolkit';

const initialContentState = {
  contentType: 'maps',
  darkMode: false,
};

const contentSlice = createSlice({
  name: 'content',
  initialState: initialContentState,
  reducers: {
    changeContentType(state, action) {
      state.contentType = action.payload;
    },
    toggleContentType(state) {
      if (state.contentType === 'maps') {
        state.contentType = 'graph';
      } else {
        state.contentType = 'maps';
      }
    },
    setDarkMode(state, action) {
      state.darkMode = action.payload;
    },
  },
});

export const contentActions = contentSlice.actions;

export default contentSlice.reducer;
